import { useParams, useNavigate } from "@tanstack/react-router"
import { useMutation } from "@tanstack/react-query"
import { authClient } from "../lib/auth-client"
import { fetcher } from "../lib/api"
import { Button } from "../components/ui"
import { useToast } from "../components/toast"

/** Invite acceptance page. Validates the token against the users email and adds them to the workspace on accept. */
export default function InvitePage() {
  const { token } = useParams({ from: "/invite/$token" })
  const navigate = useNavigate()
  const { toast } = useToast()
  const { data: session } = authClient.useSession()

  const accept = useMutation({
    mutationFn: () => fetcher<{ id: string }>("/api/members/accept", { method: "POST", body: JSON.stringify({ token }) }),
    onSuccess: (data) => {
      toast("You joined the workspace", "success")
      navigate({ to: "/workspaces/$workspaceId", params: { workspaceId: data.id } })
    },
    onError: (err: any) => toast(err.message || "Failed to accept invite", "error"),
  })

  if (!session) {
    navigate({ to: "/login" })
    return null
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-background to-muted px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border bg-card p-8 text-center shadow-xl">
        <img src="/logo.svg" alt="Taskoru" className="mx-auto mb-4 h-14 w-14 rounded-2xl shadow-md" />
        <h1 className="mb-2 text-2xl font-bold tracking-tight">Join workspace</h1>
        <p className="mb-6 text-muted-foreground">You have been invited to join a workspace on Taskoru.</p>
        <Button onClick={() => accept.mutate()} isLoading={accept.isPending} className="w-full">Accept invite</Button>
      </div>
    </div>
  )
}
